import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import {
  ExtendedWrapper,
  BoxInputs,
  InputRadius,
  Tooltip
} from "./styles";



class BorderExtended extends Component {
  changeRadius = (val, direction) => {
    const { currentValue, radiusOptions, name, updaterFn } = this.props;
    const { max } = radiusOptions;

    const { radius } = currentValue;
    const [topLeft, topRight, bottomRight, bottomLeft] = radius;

    const value = Number(val) >= max ? max : Number(val);

    let newRadius = radius;
    if (direction === "topLeft") {
      newRadius = [value, topRight, bottomRight, bottomLeft];
    }

    switch (direction) {
      case "topLeft":
        newRadius = [value, topRight, bottomRight, bottomLeft];
        break;
      case "topRight":
        newRadius = [topLeft, value, bottomRight, bottomLeft];
        break;
      case "bottomRight":
        newRadius = [topLeft, topRight, value, bottomLeft];
        break;
      case "bottomLeft":
        newRadius = [topLeft, topRight, bottomRight, value];
        break;
      default:
        newRadius = radius
        break;
    }

    updaterFn({
      prop: name,
      value: {
        ...currentValue,
        radius: newRadius,
      },
    });
  };

  render() {
    const { currentValue, radiusOptions } = this.props;

    const { radius } = currentValue;
    const [topLeft, topRight, bottomRight, bottomLeft] = radius;

    const { min: minRadius, max: maxRadius } = radiusOptions;

    return (
      <ExtendedWrapper>
        <BoxInputs>
          <InputRadius
            type="number"
            value={topLeft}
            max={maxRadius}
            min={minRadius}
            onChange={(e) => this.changeRadius(e.target.value, "topLeft")}
          />
          <Tooltip position="first">{I18n.t("editPanel.border.topLeft")}</Tooltip>
        </BoxInputs>
        <BoxInputs>
          <InputRadius
            type="number"
            value={topRight}
            max={maxRadius}
            min={minRadius}
            onChange={(e) => this.changeRadius(e.target.value, "topRight")}
          />
          <Tooltip position="second">{I18n.t("editPanel.border.topRight")}</Tooltip>
        </BoxInputs>
        <BoxInputs>
          <InputRadius
            type="number"
            value={bottomRight}
            max={maxRadius}
            min={minRadius}
            onChange={(e) => this.changeRadius(e.target.value, "bottomRight")}
          />
          <Tooltip position="third">{I18n.t("editPanel.border.bottomRight")}</Tooltip>
        </BoxInputs>
        <BoxInputs>
          <InputRadius
            type="number"
            value={bottomLeft}
            max={maxRadius}
            min={minRadius}
            onChange={(e) => this.changeRadius(e.target.value, "bottomLeft")}
          />
          <Tooltip position="fourth">{I18n.t("editPanel.border.bottomLeft")}</Tooltip>
        </BoxInputs>
      </ExtendedWrapper>
    );
  }
}

export default BorderExtended;
